import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AddOnSelector from "./AddOnSelector";
import Navbar from "./Navbar";
import "./AddOnPage.css";

const AddOnPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [currentSelection, setCurrentSelection] = useState([]);
  const [totalCost, setTotalCost] = useState(0);

  const {
    selectedSport,
    selectedCourtType,
    selectedDate,
    selectedCourtTimeSlots,
    userRole,
  } = location.state || {};

  // Redirect if no booking state
  if (!selectedSport || !selectedCourtTimeSlots) {
    navigate("/", { replace: true });
    return null;
  }

  const handleSelectionChange = (addOns, total) => {
    setCurrentSelection(addOns);
    setTotalCost(total);
  };

  const handleContinue = () => {
    navigate("/checkout-court", {
      state: {
        selectedSport,
        selectedCourtType,
        selectedDate,
        selectedCourtTimeSlots,
        selectedBookingType: "court-booking",
        userRole,
        selectedAddOns: currentSelection,
      },
    });
  };

  const handleSkip = () => {
    navigate("/checkout-court", {
      state: {
        selectedSport,
        selectedCourtType,
        selectedDate,
        selectedCourtTimeSlots,
        selectedBookingType: "court-booking",
        userRole,
        selectedAddOns: [],
      },
    });
  };

  const handleBack = () => {
    navigate(-1);
  };

  const hasSelections = currentSelection.length > 0;

  return (
    <div className="add-on-page">
      <Navbar
        selectedSport={selectedSport}
        selectedBookingType={null}
        onBookingTypeSelect={(type) => navigate("/", { state: { selectedBookingType: type } })}
        onProfileClick={() => navigate("/profile", { state: { selectedProfile: true } })}
        isProfileActive={false}
      />
      <div className="add-on-page-content">
        <div className="add-on-page-header">
          <button className="back-button" onClick={handleBack}>
            &larr; Back
          </button>
          <div className="header-actions">
            <button className="skip-button" onClick={handleSkip}>
              Skip
            </button>
            <button
              className="continue-button"
              onClick={handleContinue}
              disabled={!hasSelections}
            >
              Continue {hasSelections && `(RM ${totalCost.toFixed(2)})`}
            </button>
          </div>
        </div>
        <AddOnSelector
          selectedSport={selectedSport}
          selectedCourtTimeSlots={selectedCourtTimeSlots}
          onSelectionChange={handleSelectionChange}
          hideActions={true}
        />
      </div>
    </div>
  );
};

export default AddOnPage;
